"use client";

import { useEffect } from "react";
import Cookies from "js-cookie";
import { useSearchParams } from "next/navigation";

export default function ShowPriceCookieSetter() {
  const allowedPerson = ["link-do-pedro"];
  const searchParams = useSearchParams();
  useEffect((): void => {
    const utm = searchParams?.get("utm");

    if (utm && allowedPerson.includes(utm)) {
      Cookies.set("showPrice", "true", { expires: 7, path: "/" });
    }
  }, []);

  return null;
}
